import type { FindingAggregateResponseStatistics, FixCounts } from './api-client/api-schemas'

export const getFixableFindingsCount = (fix: FixCounts): number => {
  // Use fix-status totals as the denominator for "fixable" findings.
  // This represents findings that actually went through fix analysis (completed/failed/in-progress),
  // excluding no_recommendations ("No fix necessary") since those aren't actionable.
  return fix.status.completed + fix.status.failed + fix.status.in_progress
}

export const getScaProcessedTotal = (statistics: FindingAggregateResponseStatistics): number =>
  statistics.sca.status.completed +
  statistics.sca.status.failed +
  statistics.sca.status.blocked +
  statistics.sca.status.excluded
